import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    storageKey: { type: String, default: "component-library-theme" },
  };
  static targets = ["toggle"];

  connect() {
    this.loadTheme();
  }

  disconnect() {
    // Clean up: remove both classes when leaving the page to restore system preference
    document.documentElement.classList.remove("dark", "light");
  }

  loadTheme() {
    const savedTheme = localStorage.getItem(this.storageKeyValue);
    if (savedTheme === "dark") {
      this.enableDarkMode();
    } else if (savedTheme === "light") {
      this.enableLightMode();
    }
    // If no saved preference, leave it to system preference (no class added)
  }

  toggle() {
    if (document.documentElement.classList.contains("dark")) {
      this.enableLightMode();
    } else {
      this.enableDarkMode();
    }
  }

  enableDarkMode() {
    document.documentElement.classList.add("dark");
    document.documentElement.classList.remove("light");
    localStorage.setItem(this.storageKeyValue, "dark");
    this.updateToggleAppearance(true);
  }

  enableLightMode() {
    document.documentElement.classList.add("light");
    document.documentElement.classList.remove("dark");
    localStorage.setItem(this.storageKeyValue, "light");
    this.updateToggleAppearance(false);
  }

  updateToggleAppearance(isDark) {
    if (!this.hasToggleTarget) return;

    const toggle = this.toggleTarget;
    const container = toggle.querySelector("[data-theme-container]");
    const sunIcon = toggle.querySelector("[data-theme-sun]");
    const moonIcon = toggle.querySelector("[data-theme-moon]");

    if (isDark) {
      toggle.classList.add("bg-navy-600");
      toggle.classList.remove("bg-gray-300", "dark:bg-gray-800");
      container?.classList.add("translate-x-6");
      container?.classList.remove("translate-x-0");
      sunIcon?.classList.add("opacity-0");
      sunIcon?.classList.remove("opacity-100");
      moonIcon?.classList.add("opacity-100");
      moonIcon?.classList.remove("opacity-0");
    } else {
      toggle.classList.remove("bg-navy-600");
      toggle.classList.add("bg-gray-300", "dark:bg-gray-800");
      container?.classList.remove("translate-x-6");
      container?.classList.add("translate-x-0");
      sunIcon?.classList.remove("opacity-0");
      sunIcon?.classList.add("opacity-100");
      moonIcon?.classList.remove("opacity-100");
      moonIcon?.classList.add("opacity-0");
    }
  }
}
